
import Wrapper from "./Component/Wrapper";

function App() {
  return (
    <div className="App">
      <Wrapper/>
    </div>
  );
}

export default App;
